var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Active Opportunities")]),_c('opportunities-list',{attrs:{"opportunities":_vm.opportunities,"terms":_vm.terms,"term":_vm.term,"types":_vm.types},on:{"term-change":_vm.changeTerm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }